(() => {
  'use strict';
  const key = 'bmg:favourites:v1';
  let storageAvailable = true;
  let saved = [];
  const dialog = () => document.querySelector('[data-bmg-favourites-dialog]');
  const closeButton = () => document.querySelector('[data-bmg-favourites-close]');
  const listing = () => document.querySelector('[data-bmg-favourites-list]');
  const unique = entries => {
    const ids = new Set();
    return entries.filter(item => {
      if (!item || typeof item.id !== 'string' || !/^[a-z0-9][a-z0-9-]{0,150}$/.test(item.id) || ids.has(item.id)) return false;
      ids.add(item.id);
      return true;
    }).slice(0,120);
  };
  function load() {
    try {
      const data = JSON.parse(localStorage.getItem(key) || '[]');
      return unique(Array.isArray(data) ? data : []);
    } catch (_) { storageAvailable = false; return []; }
  }
  saved = load();
  function persist() {
    try { localStorage.setItem(key, JSON.stringify(saved)); storageAvailable = true; }
    catch (_) { storageAvailable = false; }
  }
  const isSaved = id => saved.some(item => item.id === id);
  function updateButtons() {
    document.querySelectorAll('[data-bmg-favourite-toggle]').forEach(button => {
      const active = isSaved(button.dataset.bmgFavouriteId || '');
      button.setAttribute('aria-pressed', String(active));
      const title = button.dataset.bmgFavouriteTitle || 'artwork';
      button.setAttribute('aria-label', (active ? 'Remove ' : 'Save ') + title + (active ? ' from favourites' : ' to favourites'));
      button.title = active ? 'Remove from favourites' : 'Save to favourites';
      const label = button.querySelector('[data-bmg-favourite-label]');
      if (label) label.textContent = active ? 'Saved to favourites' : 'Save to favourites';
    });
    document.querySelectorAll('[data-bmg-favourites-count]').forEach(item => { item.textContent = String(saved.length); });
  }
  function safeUrl(raw) {
    try { const url = new URL(raw, location.origin); return url.origin === location.origin && url.pathname.startsWith('/') ? url.pathname : ''; }
    catch (_) { return ''; }
  }
  function safeImage(raw) {
    try {
      const url = new URL(raw, location.href);
      return url.protocol === 'https:' && (url.hostname === 'cdn.shopify.com' || url.hostname === 'www.mitchellburns.com') ? url.href : '';
    } catch (_) { return ''; }
  }
  function drawList() {
    const list = listing();
    if (!list) return;
    list.replaceChildren();
    const actions = document.querySelector('[data-bmg-favourites-actions]');
    if (actions) actions.hidden = !saved.length;
    const note = document.querySelector('[data-bmg-favourites-note]');
    if (note) note.textContent = storageAvailable
      ? 'No account needed. Saved artworks stay in this browser on this device.'
      : 'Your browser has blocked local storage. Favourites will not be kept after you leave.';
    if (!saved.length) {
      const p = document.createElement('p');
      p.className = 'bmg-favourites-dialog__empty';
      p.textContent = 'Nothing saved yet. Use the heart beside an artwork to start a collection.';
      list.append(p);
      return;
    }
    saved.forEach(item => {
      const article = document.createElement('article');
      article.className = 'bmg-favourites-dialog__item';
      const link = document.createElement('a');
      link.className = 'bmg-favourites-dialog__artlink';
      const target = safeUrl(item.url);
      if (!target) return;
      link.href = target;
      const image = safeImage(item.image);
      if (image) {
        const img = document.createElement('img');
        img.src = image;
        img.loading = 'lazy';
        img.alt = item.title || 'Saved artwork';
        img.width = 160;
        img.height = 120;
        link.append(img);
      }
      const title = document.createElement('span');
      title.textContent = item.title || 'Artwork';
      link.append(title);
      const remove = document.createElement('button');
      remove.type = 'button';
      remove.className = 'bmg-favourites-dialog__remove';
      remove.dataset.bmgFavouriteRemove = item.id;
      remove.textContent = 'Remove';
      remove.setAttribute('aria-label', 'Remove ' + (item.title || 'artwork') + ' from favourites');
      article.append(link, remove);
      list.append(article);
    });
  }
  function refresh() { updateButtons(); drawList(); }
  function addOrRemove(button) {
    const id = button.dataset.bmgFavouriteId || '';
    const url = safeUrl(button.dataset.bmgFavouriteUrl || '');
    if (!id || !url || !/^[a-z0-9][a-z0-9-]{0,150}$/.test(id)) return;
    if (isSaved(id)) saved = saved.filter(item => item.id !== id);
    else saved = unique([...saved, {
      id,
      url,
      title: String(button.dataset.bmgFavouriteTitle || 'Artwork').slice(0,170),
      image: safeImage(button.dataset.bmgFavouriteImage || '')
    }]);
    persist();
    refresh();
  }
  function openDrawer(button) {
    const panel = dialog();
    if (!panel || typeof panel.showModal !== 'function') return;
    if (document.body.classList.contains('bmg-menu-open')) document.querySelector('[data-bmg-menu-toggle]')?.click();
    refresh();
    if (!panel.open) panel.showModal();
    panel.dataset.returnFocus = button.classList.contains('bmg-header-favourites') ? 'header' : 'menu';
    closeButton()?.focus();
  }
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-bmg-favourite-toggle]');
    if (toggle) { event.preventDefault(); event.stopPropagation(); addOrRemove(toggle); return; }
    const open = event.target.closest('[data-bmg-favourites-open]');
    if (open) { event.preventDefault(); openDrawer(open); return; }
    const remove = event.target.closest('[data-bmg-favourite-remove]');
    if (remove) {
      event.preventDefault();
      saved = saved.filter(item => item.id !== remove.dataset.bmgFavouriteRemove);
      persist(); refresh();
      return;
    }
    const close = event.target.closest('[data-bmg-favourites-close]');
    if (close) { event.preventDefault(); dialog()?.close(); }
  });
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-bmg-favourites-copy]');
    if (!button) return;
    event.preventDefault();
    const feedback = document.querySelector('[data-bmg-favourites-copy-status]');
    const lines = saved.map(item => {
      const path = safeUrl(item.url);
      return path ? (item.title || 'Artwork') + ' — ' + location.origin + path : '';
    }).filter(Boolean);
    if (!lines.length) return;
    try {
      await navigator.clipboard.writeText('My saved Mitchell Burns artworks:\n' + lines.join('\n'));
      if (feedback) feedback.textContent = 'Shortlist copied. You can paste it into a message.';
    } catch (_) {
      if (feedback) feedback.textContent = 'Copy unavailable in this browser. Use the enquiry link instead.';
    }
  });
  const panel = dialog();
  panel?.addEventListener('click', event => { if (event.target === panel) panel.close(); });
  panel?.addEventListener('close', () => {
    const selector = panel.dataset.returnFocus === 'header' ? '.bmg-header-favourites' : '[data-bmg-favourites-open]';
    document.querySelector(selector)?.focus();
  });
  window.addEventListener('storage', event => { if (event.key === key) { saved = load(); refresh(); } });
  document.querySelectorAll('[data-bmg-catalogue] .bmg-print-shop__grid').forEach(grid => {
    grid.dataset.bmgFavouriteObserved = 'true';
    new MutationObserver(() => updateButtons()).observe(grid, {childList:true});
  });
  document.addEventListener('shopify:section:load', () => {
    updateButtons();
    document.querySelectorAll('[data-bmg-catalogue] .bmg-print-shop__grid').forEach(grid => {
      if (grid.dataset.bmgFavouriteObserved) return;
      grid.dataset.bmgFavouriteObserved = 'true';
      new MutationObserver(() => updateButtons()).observe(grid, {childList:true});
    });
  });
  refresh();
})();